export const ADDRESS = {
  add_customer: "เพิ่มข้อมูลผู้ซื้อ",
  customer: "ข้อมูลผู้ซื้อ",
  address_th: "Address ภายในประเทศ",
  address_en: "Address ต่างประเทศ",
  buyer_type: "ประเภท",
  buyer_type0: "บุคคลธรรมดา",
  buyer_type1: "นิติบุคคล",
  buyer_type2: "ต่างชาติ",
  buyer_type3: "อื่นๆ",
  customer_addr: "ข้อมูลที่อยู่ผู้ซื้อ",
  buyer_company_name_type: "ชื่อ-นามสกุล/ชื่อบริษัท",
  buyer_company_name_type0: "ชื่อ-นามสกุล",
  buyer_company_name_type1: "ชื่อบริษัท",
  buyer_company_name_type2: "ชื่อ-นามสกุล",
  buyer_company_name_type3: "ชื่อ-นามสกุล",
  buyer_tax_id_type: "เลขที่บัตรประชาชน/เลขประจำตัวผู้เสียภาษี/เลขที่หนังสือเดินทาง",
  buyer_tax_id_type0: "เลขที่บัตรประชาชน",
  buyer_tax_id_type1: "เลขประจำตัวผู้เสียภาษี",
  buyer_tax_id_type2: "เลขที่หนังสือเดินทาง",
  branch: "ลำดับเลขที่สาขา",
  buyer_main_branch_no: "สำนักงานใหญ่",
  buyer_branch_no: "ลำดับสาขา",
  buyer_agree_tmp: "ผู้ซื้อยินยอมให้บันทึกข้อมูลส่วนบุคคลไว้ในระบบหรือไม่",
  buyer_agree_tmpY: "ยินยอม",
  buyer_agree_tmpN: "ไม่ยินยอม",
  seller_status: "ต้องการใช้งานข้อมูลผู้ขายนี้หรือไม่ ? ",
  seller_status_active: "ใช้งาน",
  seller_status_inactive: "ไม่ใช้งาน",
  name_addr:"ที่อยู่",
  addr: {
    house_no: "เลขที่",
    building_name: "อาคาร",
    room_no: "ห้องเลขที่",
    floor: "ชั้น",
    village_no: "หมู่",
    lane: "ซอย",
    road: "ถนน",
    sub_district: "แขวง/ตำบล",
    district: "เขต/อำเภอ",
    province: "จังหวัด",
    postcode: "รหัสไปรษณีย์",
    email: "E-mail address",
    // building_no: "อาคาร",
    phone: "เบอร์ติดต่อ",
    fax: "Tel",
    inter_province: "State/Province",
    inter_postcode: "Post Code",
    inter_country: "Country",
    inter_tel: "Tel",
    inter_address_line1: "Address",
  },

  seller_addr: "ข้อมูลที่อยู่ผู้ขาย",
  seller: "ข้อมูลผู้ขาย",
  seller_type: "ประเภท",
  seller_type1: "นิติบุคคล",
  seller_name: "ชื่อ-นามสกุล/ชื่อบริษัท",
  seller_tax_id: "เลขประจำตัวผู้เสียภาษี",
  seller_branch_name: "Branch Name:",
  seller_bu: "BU code:",
  seller_storeid: "Store ID:",
  seller_source_system: "Source system",
  seller_branch_id: "Branch ID:",
  seller_branch: "Branch code:",
  sel_numberone: "1.",
  sel_numbertwo: "2.",
  province_no: "รหัสจังหวัด",
  phone_no: "เบอร์โทรศัพท์",
  phone_next: "เบอร์ต่อ",
  seller_fax: "โทรสาร",
  search_address: "ระบุ : แขวง/ตำบล เขต/อำเภอ จังหวัด หรือ รหัสไปรษณีย์ (อย่างใดอย่างหนึ่ง) เพื่อระบุที่อยู่"
};
